<template>
    <li v-if="shouldDisplay" class="overview-list-item">
        <label class="overview-list-item__label">{{
            $t('pages.vehicle.overview_driving_license_eligbility_label')
        }}</label>
        <span class="overview-list-item__value">
            {{ drivingLicenseEligibility }}
        </span>
    </li>
</template>

<script>
import { ASSET_SUB_TYPE_MOTORHOME, ASSET_SUB_TYPE_CAMPERVAN } from '~/config/assetTypes';

export default {
    props: {
        vehicle: {
            type: Object,
            default: null,
        },
    },
    computed: {
        shouldDisplay() {
            // Show only for motorhomes and campervan
            return (
                !this.vehicle.subType ||
                this.vehicle.subType === ASSET_SUB_TYPE_MOTORHOME ||
                this.vehicle.subType === ASSET_SUB_TYPE_CAMPERVAN
            );
        },
        drivingLicenseEligibility() {
            // Note: If this is changed, it also needs to be changed in DrivingLicenseForm.vue
            if (this.vehicle.maximumAuthorizedMass <= 3500) {
                return 'B';
            }

            return this.$store.getters.isCountryFinland
                ? this.$t('vehicle_fields.driving_license_eligibility_c1_fi')
                : this.$t('vehicle_fields.driving_license_eligibility_c1');
        },
    },
};
</script>
